import React, { FC } from "react";

import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from "@heroicons/react/20/solid";
import classNames from "classnames";
import { usePagination } from "src/contexts/PaginationContext";

const Pagination: FC<any> = () => {
  const { pagination, onNext, onBack, onSetPage } = usePagination();
  const { page, pageCount } = pagination;

  const onClickPage = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    value: number
  ) => {
    e.preventDefault();
    onSetPage(value);
  };

  const next = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onNext();
  };

  const back = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onBack();
  };

  if (pageCount === 1) return null;

  return (
    <nav className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
      <div className="-mt-px flex w-0 flex-1">
        {page > 1 && (
          <a
            href="#"
            className="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
            onClick={back}
          >
            <ArrowLongLeftIcon
              className="mr-3 h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
            Atras
          </a>
        )}
      </div>
      <div className="hidden md:-mt-px md:flex">
        {Array.from(Array(pageCount).keys()).map(
          (entry: number, index: number) => (
            <a
              key={entry}
              href="#"
              className={classNames(
                "inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700",
                { "border-primary text-indigo-600": entry + 1 === page }
              )}
              onClick={(e) => onClickPage(e, entry + 1)}
            >
              {entry + 1}
            </a>
          )
        )}
      </div>
      <div className="-mt-px flex w-0 flex-1 justify-end">
        {page < pageCount && (
          <a
            href="#"
            className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
            onClick={next}
          >
            Siguiente
            <ArrowLongRightIcon
              className="ml-3 h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </a>
        )}
      </div>
    </nav>
  );
};

export default Pagination;
